import React from 'react'
import {FaGithub, FaLinkedin, FaInstagram, FaReact, FaHtml5, FaCss3, FaPython, FaSass, FaInfinity} from 'react-icons/fa'
import { IoLogoJavascript } from "react-icons/io";
import {DiAndroid, DiDjango} from "react-icons/di";
import {BiLogoFlutter, BiLogoPostgresql} from "react-icons/bi";
import { SiPostman } from "react-icons/si";
import Img1 from '../../assets/img1.jpg';
import { TypeAnimation } from 'react-type-animation';
export default function Header() {
  return (
    <div className='w-full min-h-[85vh] lg:min-h-[78vh]  mt-6 mb-12  flex justify-center items-center'>
         <div className="container mx-auto">
        <div className="flex flex-col gap-y-12 lg:flex-row lg:flex-items-center lg:gap-x-36">
          {/* text */}
          <div className="flex-1 text-center font-secondary lg:text-left p-4">
            <h1
 
              className="text-[40px] text-indigo font-bold leading-[0.8] lg:text-[100px]"
            >
              Tunahan Tatlı
            </h1>
            <br />
            <div
              className="mb-6 text-[36px] lg:text-[56px] font-secondary
            font-semibold text-deepPurple uppercase leading-[1]"
            >
              <span className="mr-4">I am {" "}
                <span> 
                <TypeAnimation
                sequence={["fronted", 2000, "backend", 2000, "blockchain", 2000, "full stack",2000]}
                speed={50}
                className="text-accent"
                wrapper="span"
                repeat={Infinity}
              />
                </span> <br /> developer</span>
              
            </div>
            <div
              className="mb-8 max-w-lg mx-auto lg:mx-0 "
            >
              <div className='md:flex hidden lg:justify-start items-center gap-3 text-[24px]'>
                <span className='justify-center items-center'><FaHtml5 className='text-accent'/></span>
                <span className='justify-center items-center'><FaCss3 className='text-primary'/></span>
                <span className='justify-center items-center'><FaSass className='text-pink'/></span>
                <span className='justify-center items-center'><IoLogoJavascript className='bg-warning'/></span>
                <span className='justify-center items-center'><FaReact className='text-primary bg-dark'/></span>
                <span className='justify-center items-center'><FaPython className='bg-amber text-blue-950'/></span>
                <span className='justify-center items-center'><DiDjango className='text-teal'/></span>
                <span className='justify-center items-center'><FaInfinity className='text-pink'/></span>
                <span className='justify-center items-center'><BiLogoPostgresql className='text-blue-800/80'/></span>
                <span className='justify-center items-center'><SiPostman className='text-accent'/></span>
                <span className='justify-center items-center'><DiAndroid className='text-success'/></span>
                <span className='justify-center items-center'><BiLogoFlutter className='text-info'/></span>
              </div>
            </div>
            {/* Socials */}
            <div
              className="flex text-white text-[26px] gap-x-6 max-w-max mx-auto
              lg:mx-0 mb-2"
            >
              <a href="https://github.com/tunahantatli/" title='gitgub' className='hover:font-bold'>
                <FaGithub />
              </a>
              <a
                href="https://www.linkedin.com/in/tunahantatli/"
                className=" hover:text-primary"
                title='linkedin'
              >
                <FaLinkedin />
              </a>
              <a
                href="https://www.instagram.com/tunahantatli/"
                className="hover:text-rose-600 hover:font-bold "
                title='instagram'
              >
                <FaInstagram />
              </a>
            </div>
          </div>
          {/* images */}
          <div
            className="hidden lg:flex flex-col  "
          >
            <img src={Img1} alt="" className='border-[1px] rounded-2xl z-50 perspective shadow-2xl h-[400px] hover:shadow-dark hover:rotate-45 transform transition-transform duration-300 ease-in-out' />
          </div>
        </div>
      </div>
    </div>
  )
}
